/* eslint-disable jsx-a11y/img-redundant-alt */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from "react";
import "./AddForm.css";
import Button from "@material-ui/core/Button";
import TextField from "@material-ui/core/TextField";
import AuthApi from "../../../Services/Authapi";
import { resolveImageUrl } from "../../../../utils/imageUrl";
import swal from "sweetalert";
import Grid from "@material-ui/core/Grid";
import FormControl from "@material-ui/core/FormControl";
import FormLabel from "@material-ui/core/FormLabel";
import Radio from "@material-ui/core/Radio";
import RadioGroup from "@material-ui/core/RadioGroup";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import Typography from "@material-ui/core/Typography";
import Avatar from "@material-ui/core/Avatar";
import FontAwesomeIconComponent from "../../../Layouts/FontAwesomeIconComponent";
import MenuItem from "@material-ui/core/MenuItem";
import InputLabel from "@material-ui/core/InputLabel";
import Select from "@material-ui/core/Select";
import Popover from "@material-ui/core/Popover";
import Divider from "@material-ui/core/Divider";
import ListItemText from "@material-ui/core/ListItemText";
import Box from "@material-ui/core/Box";
import { makeStyles } from "@material-ui/core/styles";
import Accordion from "@material-ui/core/Accordion";
import AccordionSummary from "@material-ui/core/AccordionSummary";
import AccordionDetails from "@material-ui/core/AccordionDetails";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import VisibilityIcon from '@material-ui/icons/Visibility';
import VisibilityOffIcon from '@material-ui/icons/VisibilityOff';
import InputAdornment from '@material-ui/core/InputAdornment';
import IconButton from '@material-ui/core/IconButton';
import CloudUploadIcon from '@material-ui/icons/CloudUpload';
import SearchIcon from '@material-ui/icons/Search';
import CheckIcon from '@material-ui/icons/Check';
import defaultAvatar from '../../../../Images/person.jpg';
import { createSwalLoaderNode } from "../../../Layouts/swalLoader";

const useStyles = makeStyles((theme) => ({
  root: {
    border: "1px solid rgba(0, 0, 0, .125)",
    width: "100%",
  },
  formShell: {
    '& .MuiTypography-root': {
      color: theme.palette.type === 'dark' ? '#ffffff' : 'var(--hrms-primary-blue-text, #1f3f5b)',
    },
    '& .MuiInputLabel-root, & .MuiFormLabel-root': {
      color: 'var(--hrms-primary-blue-end, #036dda)',
      fontWeight: 700,
    },
    '& .MuiInputLabel-root.Mui-focused, & .MuiFormLabel-root.Mui-focused': {
      color: 'var(--hrms-primary-blue-end, #036dda)',
    },
    '& .MuiOutlinedInput-input, & .MuiInputBase-input, & .MuiSelect-select, & .MuiFormControlLabel-label': {
      color: theme.palette.type === 'dark' ? '#ffffff' : 'var(--hrms-primary-blue-text, #1f3f5b)',
      WebkitTextFillColor: theme.palette.type === 'dark' ? '#ffffff' : 'var(--hrms-primary-blue-text, #1f3f5b)',
      caretColor: theme.palette.type === 'dark' ? '#ffffff' : 'var(--hrms-primary-blue-text, #1f3f5b)',
    },
    '& .MuiSvgIcon-root, & .MuiSelect-icon': {
      color: theme.palette.type === 'dark' ? '#ffffff' : 'var(--hrms-primary-blue-end, #036dda)',
    },
    '& .MuiRadio-root': {
      color: theme.palette.type === 'dark' ? '#ffffff' : 'var(--hrms-primary-blue-end, #036dda)',
    },
    '& .MuiRadio-colorSecondary.Mui-checked': {
      color: 'var(--hrms-primary-blue-end, #036dda)',
    },
    '& .MuiOutlinedInput-root': {
      color: theme.palette.type === 'dark' ? '#ffffff' : '#111111',
    },
    '& .MuiOutlinedInput-root .MuiOutlinedInput-notchedOutline': {
      borderColor: theme.palette.type === 'dark' ? 'rgba(255, 255, 255, 0.18)' : 'var(--hrms-field-border, #036dda)',
    },
    '& input::placeholder, & textarea::placeholder': {
      color: theme.palette.type === 'dark' ? '#ffffff' : '#111111',
      opacity: 1,
    },
    '& input[type="date"]': {
      color: theme.palette.type === 'dark' ? '#ffffff' : '#111111',
      WebkitTextFillColor: theme.palette.type === 'dark' ? '#ffffff' : '#111111',
    },
    '& input[type="date"]::-webkit-datetime-edit, & input[type="date"]::-webkit-datetime-edit-fields-wrapper, & input[type="date"]::-webkit-datetime-edit-text, & input[type="date"]::-webkit-datetime-edit-month-field, & input[type="date"]::-webkit-datetime-edit-day-field, & input[type="date"]::-webkit-datetime-edit-year-field': {
      color: theme.palette.type === 'dark' ? '#ffffff' : '#111111',
      WebkitTextFillColor: theme.palette.type === 'dark' ? '#ffffff' : '#111111',
    },
    '& input[type="date"]::-webkit-calendar-picker-indicator': {
      filter: theme.palette.type === 'dark' ? 'brightness(0) invert(1)' : 'none',
      opacity: 1,
    },
    '& .MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline': {
      borderColor: theme.palette.type === 'dark' ? 'var(--hrms-primary-blue-end, #036dda)' : 'var(--hrms-field-border, #036dda)',
    },
    '& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline': {
      borderColor: theme.palette.type === 'dark' ? 'var(--hrms-primary-blue-end, #036dda)' : 'var(--hrms-field-border-hover, #036dda)',
    },
  },
  heading: {
    fontSize: theme.typography.pxToRem(15),
    fontWeight: theme.typography.fontWeightRegular,
  },
  uploadArea: {
    width: '100%',
    minHeight: '215px',
    border: `2px dashed ${theme.palette.type === 'dark' ? 'rgba(255, 255, 255, 0.2)' : 'var(--hrms-primary-blue-border, #1864bc)'}`,
    borderRadius: '1rem',
    backgroundColor: theme.palette.type === 'dark' ? 'rgba(255, 255, 255, 0.05)' : '#f8fafc',
    position: 'relative',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    cursor: 'pointer',
    transition: 'all 0.3s ease',
    padding: theme.spacing(1),
    '&:hover': {
      backgroundColor: theme.palette.type === 'dark' ? 'rgba(255, 255, 255, 0.1)' : '#f1f5f9',
      borderColor: theme.palette.type === 'dark' ? 'rgba(255, 255, 255, 0.4)' : 'var(--hrms-primary-blue-end, #036dda)',
    },
  },
  uploadAreaActive: {
    backgroundColor: theme.palette.type === 'dark' ? 'rgba(255, 255, 255, 0.15)' : '#ffffff',
    borderColor: 'var(--hrms-primary-blue-end, #036dda)',
    boxShadow: `0 0 0 4px ${theme.palette.type === 'dark' ? 'rgba(255, 255, 255, 0.1)' : 'rgba(27, 111, 209, 0.12)'}`,
  },
  fileInput: {
    display: 'none',
  },
}));

const EMPTY_SELECT_VALUE = "__empty__";

const iniuservalid = {
  firstName: "",
  lastName: "",
  email: "",
  personal_email: "", // Added personal_email
  gender: "",
  dob: "",
  photo: null,
  imageName: "",
  qualification: "",
  last_organization: "",
  password: "",
  roleName: "",
  salary: "",
  mobileNo: "",
  bankName: "",
  bankAccNo: "",
  doj: "",
  location: "",
  department: "",
  designation: "",
  designation_id: "",
  reporting_person_id: [],
  role: false,
};

const Addform = (props) => {
  const styles = useStyles();
  const classes = props;
  const [roleOptions, setRoleOptions] = React.useState([]);
  const [formValues, setFormValues] = useState(iniuservalid);
  const [formErrors, setFormErrors] = useState({});
  const [qualifications, setQualifications] = useState([]);
  const [Departmentshow, setDepartmentshow] = useState([]);
  const [Departmentshowd, setDepartmentshow1] = useState([]);
  const [reporting_person_id, setSelectuser] = useState([]);
  const [isSubmitting, setIsSubmitting] = useState(false);

  const [showPassword, setShowPassword] = useState(false);
  const [dragActive, setDragActive] = useState(false);
  const fileInputRef = React.useRef(null);
  const [dropdownAnchorEl, setDropdownAnchorEl] = useState(null);
  const [activeDropdown, setActiveDropdown] = useState("");
  const [dropdownSearch, setDropdownSearch] = useState({
    qualification: "",
    roleName: "",
    department: "",
    designation: "",
    reporting_person_id: "",
  });
  const [explicitEmptySelections, setExplicitEmptySelections] = useState({
    department: false,
    designation: false,
    reporting_person_id: false,
    qualification: false,
    roleName: false,
  });



  const handleChange1 = (e) => {
    const { name, value } = e.target;
    setFormValues({ ...formValues, [name]: value });
    if (formErrors[name]) {
      setFormErrors((prevErrors) => ({
        ...prevErrors,
        [name]: "",
      }));
    }
    if (formErrors.submit) {
      setFormErrors((prevErrors) => ({
        ...prevErrors,
        submit: "",
      }));
    }
    // console.log(formValues);
  };

  const normalizeFormValues = (values) => ({
    ...values,
    firstName: (values.firstName || "").trim(),
    lastName: (values.lastName || "").trim(),
    email: (values.email || "").trim(),
    personal_email: (values.personal_email || "").trim(),
    qualification: (values.qualification || "").trim(),
    password: values.password || "",
    roleName: (values.roleName || "").trim(),
    salary: (values.salary || "").trim(),
    last_organization: (values.last_organization || "").trim(),
    mobileNo: (values.mobileNo || "").trim(),
    bankName: (values.bankName || "").trim(),
    bankAccNo: (values.bankAccNo || "").trim(),
    location: (values.location || "").trim(),
    department: (values.department || "").trim(),
    designation: (values.designation || "").trim(),
  });

  const validate = (values) => {
    let errors = {};
    const regex = /^[a-zA-Z][a-zA-Z\s]*$/;
    const emailRegx =
      /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    const dobRegx =
      /^\d{4}[\/\-](0?[1-9]|1[012])[\/\-](0?[1-9]|[12][0-9]|3[01])$/;
    const passwordRegx = /^(?=\S{8,16}$)(?=.*\d)(?=.*[A-Z])(?=.*[@#$%^&+=]).*$/;
    const Numeric = /^\d+$/;

    if (!values.firstName) {
      errors.firstName = "Cannot be blank";
    } else if (!regex.test(values.firstName)) {
      errors.firstName = "Invalid firstName format";
    }

    if (!values.lastName) {
      errors.lastName = "Cannot be blank";
    } else if (!regex.test(values.lastName)) {
      errors.lastName = "Invalid lastName format";
    }

    if (!values.email) {
      errors.email = "Cannot be  blank";
    } else if (!emailRegx.test(values.email)) {
      errors.email = "Invalid email format";
    }

    if (values.personal_email && !emailRegx.test(values.personal_email)) {
      errors.personal_email = "Invalid personal email format";
    }

    if (!values.dob) {
      errors.dob = "Cannot be  blank";
    } else if (!dobRegx.test(values.dob)) {
      errors.dob = "Invalid dob format";
    }

    if (values.qualification && !regex.test(values.qualification)) {
      errors.qualification = "Invalid qualification format";
    }

    if (!values.gender) {
      errors.gender = "Please select gender";
    }

    if (!values.password) {
      errors.password = "Password cannot be blank";
    } else if (!passwordRegx.test(values.password)) {
      errors.password = "Password must be 8 to 16 characters with at least one number, one capital letter, and one special character";
    }

    if (!values.salary) {
      errors.salary = "Cannot be blank";
    } else if (!Numeric.test(values.salary)) {
      errors.salary = "Must Be Numeric";
    }

    if (!values.doj) {
      errors.doj = "Cannot be  blank";
    } else if (!dobRegx.test(values.doj)) {
      errors.doj = "Invalid dob format";
    }

    // if (!values.reporting_person_id) { 
    //   errors.reporting_person_id = "Cannot be  blank";
    // } 

    return errors;
  };


  useEffect(() => {
    getQualificationData();
    Departmentshow1()
    Departmentshow2()
    Selectuser1()
  }, []);

  const getQualificationData = async () => {
    try {
      const response = await AuthApi.getQulification();
      if (response && response.data) {
        setQualifications(response.data);
      }
    } catch (error) {
      console.error('Error fetching qualification data:', error);
    }
  };
  const Selectuser1 = async () => {
    try {
      let users = await AuthApi.getData();
      if (users && users.data) {
        // Filter users where user_logged is 1
        const filteredUsers = users.data.filter(user => user.user_logged === 1);
        setSelectuser(filteredUsers);
      }
    } catch (error) {
      console.error('Error fetching qualification data:', error);
    }
  };


  const Departmentshow1 = async () => {
    try {
      const response = await AuthApi.Departmentshow();
      if (response && response.data) {
        setDepartmentshow(response.data);
      }
    } catch (error) {
      console.error('Error fetching qualification data:', error);
    }
  };


  const Departmentshow2 = async () => {
    try {
      const response = await AuthApi.Departmentshow1();
      if (response && response.data) {
        setDepartmentshow1(response.data);
      }
    } catch (error) {
      console.error('Error fetching qualification data:', error);
    }
  };







  async function RoleData() {
    let role = await AuthApi.getRole();
    if (role && role.status === true) {
      if (Object.keys(role.data).length > 0) {
        const mappedRoles = Object.keys(role.data).map((key) => ({
          value: role.data[key].name,
          label: role.data[key].name,
        }));
        setRoleOptions(mappedRoles);
      } else {
        setRoleOptions([]);
      }
    }
  }
  React.useEffect(() => { RoleData() }, []);

  const handleFileUpload = async (file) => {
    const postData = new FormData();
    postData.append("file", file);
    let updaImg = await AuthApi.updateImg(postData);
    if (updaImg && updaImg.status === true) {
      setFormValues({
        ...formValues,
        photo: resolveImageUrl(updaImg.data.image_url),
        imageName: updaImg.data.image_name,
      });
    }
  };

  const imgUpload = (e) => {
    if (e.target.files && e.target.files[0]) {
      handleFileUpload(e.target.files[0]);
    }
  };

  const handleDrag = (e) => {
    e.preventDefault();
    e.stopPropagation();
    if (e.type === "dragenter" || e.type === "dragover") {
      setDragActive(true);
    } else if (e.type === "dragleave") {
      setDragActive(false);
    }
  };

  const handleDrop = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setDragActive(false);
    if (e.dataTransfer.files && e.dataTransfer.files[0]) {
      handleFileUpload(e.dataTransfer.files[0]);
    }
  };

  const removeImg = async (e) => {
    if (e) {
      e.preventDefault();
      e.stopPropagation();
    }

    const resetImageState = () => {
      setFormValues((prevValues) => ({
        ...prevValues,
        photo: null,
        imageName: "",
      }));
      if (fileInputRef.current) {
        fileInputRef.current.value = "";
      }
    };

    if (!formValues.photo) {
      resetImageState();
      return;
    }

    try {
      let imageLink = formValues.photo;
      if (imageLink && imageLink.indexOf("/", 7) !== -1) {
        imageLink = imageLink.substr(imageLink.indexOf("/", 7) + 1);
      }

      const remImg = await AuthApi.deleteImg(imageLink);
      if (remImg && remImg.status === true) {
        resetImageState();
      } else {
        resetImageState();
      }
    } catch (error) {
      console.error(error);
      resetImageState();
    }
  };

  const getUserFullName = (user) => {
    if (!user) return "";
    return [user.firstName, user.lastName].filter(Boolean).join(" ").trim();
  };

  const getUserInitials = (user) => {
    const fullName = getUserFullName(user);
    if (!fullName) return "U";
    return fullName
      .split(" ")
      .filter(Boolean)
      .slice(0, 2)
      .map((part) => part[0].toUpperCase())
      .join("");
  };

  const openSearchableDropdown = (field, event) => {
    setActiveDropdown(field);
    setDropdownAnchorEl(event.currentTarget);
    setDropdownSearch((prev) => ({
      ...prev,
      [field]: "",
    }));
  };

  const closeSearchableDropdown = () => {
    setDropdownAnchorEl(null);
    setActiveDropdown("");
  };

  const updateDropdownValue = (field, value) => {
    setFormValues((prev) => {
      if (field === "designation") {
        const selectedId = Departmentshow.find((dept) => dept.designation === value)?.id || "";
        return {
          ...prev,
          designation: value,
          designation_id: value ? selectedId : "",
        };
      }
      if (field === "reporting_person_id") {
        return {
          ...prev,
          reporting_person_id: value ? [value] : [],
        };
      }
      return {
        ...prev,
        [field]: value,
      };
    });

    setExplicitEmptySelections((prev) => ({
      ...prev,
      [field]: value === "",
    }));

    if (formErrors[field]) {
      setFormErrors((prevErrors) => ({
        ...prevErrors,
        [field]: "",
      }));
    }

    closeSearchableDropdown();
  };

  const getSelectedDropdownLabel = (field) => {
    if (field === "reporting_person_id") {
      const selectedId = Array.isArray(formValues.reporting_person_id) ? formValues.reporting_person_id[0] : "";
      const selectedUser = reporting_person_id.find((user) => String(user.id) === String(selectedId));
      return selectedUser ? getUserFullName(selectedUser) || selectedUser.firstName : "";
    }
    return formValues[field] || "";
  };

  const getDropdownOptions = (field) => {
    if (field === "qualification") {
      return qualifications.map((item) => ({
        value: item.qualification,
        label: item.qualification,
      }));
    }
    if (field === "roleName") {
      return roleOptions;
    }
    if (field === "department") {
      return Departmentshowd.map((item) => ({
        value: item.department,
        label: item.department,
      }));
    }
    if (field === "designation") {
      return Departmentshow.map((item) => ({
        value: item.designation,
        label: item.designation,
      }));
    }
    return reporting_person_id.map((user) => ({
      value: user.id,
      label: getUserFullName(user) || user.firstName,
      photo: user.photo || "",
      initials: getUserInitials(user),
    }));
  };

  const renderSearchableSelect = (field, label, options, errorKey = field) => {
    const searchValue = dropdownSearch[field] || "";
    const shouldShowSearch = field === "reporting_person_id";
    const filteredOptions = options.filter((option) =>
      !shouldShowSearch || (option.label || "").toLowerCase().includes(searchValue.toLowerCase())
    );
    const selectedValue = getSelectedDropdownLabel(field);
    const showAvatar = field === "reporting_person_id";
    const hasError = Boolean(formErrors[errorKey]);
    const noneLabel = field === "reporting_person_id" ? "None" : "None";

    return (
      <React.Fragment>
        <TextField
          fullWidth
          variant="outlined"
          label={label}
          value={selectedValue || (explicitEmptySelections[field] ? "None" : "")}
          onClick={(event) => openSearchableDropdown(field, event)}
          error={hasError}
          inputProps={{ readOnly: true }}
          InputProps={{
            endAdornment: (
              <InputAdornment position="end">
                <ExpandMoreIcon />
              </InputAdornment>
            ),
            style: {
              cursor: "pointer",
            },
          }}
        />
        <Popover
          open={activeDropdown === field}
          anchorEl={dropdownAnchorEl}
          onClose={closeSearchableDropdown}
          anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
          transformOrigin={{ vertical: "top", horizontal: "left" }}
          PaperProps={{
            className: "user-searchable-popover-paper",
          }}
        >
          <Box p={1.5} className="user-searchable-popover-header">
            <Typography variant="subtitle2" className="user-searchable-popover-title">
              {label}
            </Typography>
            {shouldShowSearch && (
              <TextField
                className="attendance-user-search-field"
                fullWidth
                size="small"
                placeholder="Search..."
                variant="outlined"
                value={searchValue}
                onChange={(e) =>
                  setDropdownSearch((prev) => ({
                    ...prev,
                    [field]: e.target.value,
                  }))
                }
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <SearchIcon fontSize="small" />
                    </InputAdornment>
                  ),
                }}
              />
            )}
          </Box>
          <Divider />
          <div className="user-searchable-popover-list">
            <MenuItem
              className="attendance-user-option"
              onClick={() => updateDropdownValue(field, "")}
            >
              <ListItemText primary={noneLabel} />
              {!selectedValue && <CheckIcon style={{ color: "#16a34a", fontSize: "1.2rem" }} />}
            </MenuItem>
            {filteredOptions.map((option) => {
              const isSelected = String(selectedValue) === String(option.label);
              return (
                <MenuItem
                  key={`${field}-${option.value}`}
                  className="attendance-user-option"
                  onClick={() => updateDropdownValue(field, option.value)}
                >
                  <Box display="flex" alignItems="center" width="100%">
                    {showAvatar && (
                      <Avatar
                        src={option.photo || ""}
                        className="user-searchable-option-avatar"
                      >
                        {option.initials}
                      </Avatar>
                    )}
                    <ListItemText primary={option.label} />
                    {isSelected && <CheckIcon style={{ color: "#16a34a", fontSize: "1.2rem" }} />}
                  </Box>
                </MenuItem>
              );
            })}
            {filteredOptions.length === 0 && (
              <div className="user-searchable-empty-state">No results found</div>
            )}
          </div>
        </Popover>
        {hasError && <span className="error">{formErrors[errorKey]}</span>}
      </React.Fragment>
    );
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const normalizedValues = normalizeFormValues(formValues);
    setFormValues(normalizedValues);
    setFormErrors(validate(normalizedValues));
    setIsSubmitting(true);
  };

  useEffect(() => {
    if (Object.keys(formErrors).length === 0 && isSubmitting) {
      createUser();
    }
  }, [formErrors]);

  const getCreateUserErrorMessage = (response) => {
    if (!response) {
      return "Failed to save user. Please try again.";
    }

    if (response.errors && typeof response.errors === "object") {
      const fieldMessages = Object.values(response.errors)
        .flat()
        .filter(Boolean);

      if (fieldMessages.length > 0) {
        return fieldMessages.join("\n");
      }
    }

    return response.message || "Failed to save user. Please check details and try again.";
  };

  const getCreateUserFieldErrors = (response) => {
    if (!response || !response.errors || typeof response.errors !== "object") {
      return {};
    }

    const mappedErrors = {};

    Object.entries(response.errors).forEach(([field, messages]) => {
      const normalizedMessage = Array.isArray(messages)
        ? messages.filter(Boolean).join(", ")
        : messages;

      if (!normalizedMessage) {
        return;
      }

      if (field === "reporting_person_id" || field === "assigned_users") {
        mappedErrors.reporting_person_id = normalizedMessage;
        return;
      }

      if (field === "role" || field === "roleName") {
        mappedErrors.roleName = normalizedMessage;
        return;
      }

      mappedErrors[field] = normalizedMessage;
    });

    return mappedErrors;
  };

  const createUser = async () => {
    swal({
      title: "Loading",
      text: "Please wait...",
      buttons: false,
      closeOnClickOutside: false,
      closeOnEsc: false,
      content: createSwalLoaderNode(),
    });
    try {
      const normalizedValues = normalizeFormValues(formValues);
      let create = await AuthApi.createUser(normalizedValues);
      swal.close();
      setIsSubmitting(false);

      if (create && create.status === true) {
        swal("Success", "User added successfully", "success").then(() => {
          props.history.push("/users");
        });
      } else {
        const apiFieldErrors = getCreateUserFieldErrors(create);

        if (Object.keys(apiFieldErrors).length > 0) {
          setFormErrors((prevErrors) => ({
            ...prevErrors,
            ...apiFieldErrors,
            submit: "",
          }));
          return;
        }

        setFormErrors((prevErrors) => ({
          ...prevErrors,
          submit: getCreateUserErrorMessage(create),
        }));
      }
    } catch (error) {
      swal.close();
      setIsSubmitting(false);
      setFormErrors((prevErrors) => ({
        ...prevErrors,
        submit: "An unexpected error occurred. Please try again after some time.",
      }));
      console.error("Error updating users:", error);
    }
  };

  const handleTogglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };

  return (
    <div>
      <form className={`${classes.form || ''} common-form-fields ${styles.formShell}`} onSubmit={handleSubmit}>
        <Grid container className={classes.root} spacing={5}>
          <Grid item xs={4}>
            <TextField
              fullWidth
              id="firstName"
              name="firstName"
              label="First Name"
              variant="outlined"
              error={formErrors.firstName && true}
              value={formValues.firstName}
              onChange={handleChange1}
              className={formErrors.firstName && "input-error"}
            />
            {formErrors.firstName && (
              <span className="error">{formErrors.firstName}</span>
            )}
          </Grid>
          <Grid item xs={4}>
            <TextField
              fullWidth
              id="lastName"
              name="lastName"
              label="Last Name"
              variant="outlined"
              error={formErrors.lastName && true}
              value={formValues.lastName}
              onChange={handleChange1}
              className={formErrors.lastName && "input-error"}
            />
            {formErrors.lastName && (
              <span className="error">{formErrors.lastName}</span>
            )}
          </Grid>
          <Grid item xs={4}>
            <TextField
              fullWidth
              id="email"
              name="email"
              label="Email"
              variant="outlined"
              error={formErrors.email && true}
              value={formValues.email}
              onChange={handleChange1}
              className={formErrors.email && "input-error"}
            />
            {formErrors.email && (
              <span className="error">{formErrors.email}</span>
            )}
          </Grid>
          {/* Personal Email Field */}

        </Grid>

        <Grid container className={classes.root} spacing={5}>
          <Grid item xs={4} style={{ display: "flex" }}>
            <FormControl component="fieldset">
              <Grid container className={classes.root} spacing={4}>
                <Grid item xs={12} style={{ display: "flex" }}>
                  <FormLabel component="legend">Gender</FormLabel>
                </Grid>
              </Grid>
              <RadioGroup
                aria-label="gender"
                name="gender"
                // defaultValue="female"
                onChange={handleChange1}
              >
                <Grid container className={classes.root} spacing={2}>
                  <Grid textalign="left" item xs={6}>
                    <FormControlLabel
                      value="female"
                      control={<Radio />}
                      label="Female"
                    />
                  </Grid>
                  <Grid item xs={6}>
                    <FormControlLabel
                      value="male"
                      control={<Radio />}
                      label="Male"
                    />
                  </Grid>
                </Grid>
              </RadioGroup>
            </FormControl>
            {formErrors.gender && (
              <span className="error">{formErrors.gender}</span>
            )}
          </Grid>
          <Grid item xs={4}>
            <TextField
              fullWidth
              id="date"
              variant="outlined"
              label="Birthday"
              name="dob"
              type="date"
              error={formErrors.dob && true}
              value={formValues.dob}
              onChange={handleChange1}
              className={`${formErrors.dob ? "input-error" : ""} ${classes.textField || ""}`}
              InputLabelProps={{
                shrink: true,
              }}
            />
            {formErrors.dob && <span className="error">{formErrors.dob}</span>}
          </Grid>
          <Grid item xs={4}>
            <TextField
              fullWidth
              id="date"
              variant="outlined"
              label="Date of Join"
              name="doj"
              type="date"
              error={formErrors.doj && true}
              value={formValues.doj}
              onChange={handleChange1}
              className={`${formErrors.doj ? "input-error" : ""} ${classes.textField || ""}`}
              InputLabelProps={{
                shrink: true,
              }}
            />
            {formErrors.doj && (
              <span className="error">{formErrors.doj}</span>
            )}
          </Grid>
        </Grid>

        <Grid container className={classes.root} spacing={5}>
          <Grid item xs={4}>
            {renderSearchableSelect(
              "qualification",
              "Qualification",
              getDropdownOptions("qualification")
            )}
          </Grid>


          <Grid item xs={4}>
            <TextField
              fullWidth
              id="outlined-basic"
              name="salary"
              label="Salary"
              variant="outlined"
              value={
                formValues && formValues.salary !== null
                  ? formValues.salary
                  : null
              }
              onChange={handleChange1}
              className={formErrors.salary && "input-error"}
              error={formErrors.salary && true}
            />
            {formErrors.salary && (
              <span className="error">{formErrors.salary}</span>
            )}
          </Grid>
          <Grid item xs={4}>
            <TextField
              fullWidth
              id="outlined-basic"
              name="password"
              type={showPassword ? 'text' : 'password'}
              label="Password"
              variant="outlined"
              error={formErrors.password && true}
              value={formValues.password}
              onChange={handleChange1}
              className={formErrors.password && "input-error"}
              InputProps={{
                endAdornment: (
                  <InputAdornment position="end">
                    <IconButton
                      aria-label="toggle password visibility"
                      onClick={handleTogglePasswordVisibility}
                    >
                      {showPassword ? <VisibilityIcon /> : <VisibilityOffIcon />}
                    </IconButton>
                  </InputAdornment>
                ),
              }}
            />
            {formErrors.password && (
              <span className="error">{formErrors.password}</span>
            )}
          </Grid>
        </Grid>

        <Grid container className={classes.root} spacing={5}>
          <Grid item xs={4}>
            {renderSearchableSelect(
              "roleName",
              "Role",
              getDropdownOptions("roleName")
            )}
          </Grid>
          <Grid item xs={4}>
            <TextField
              fullWidth
              id="personal_email"
              name="personal_email"
              label="Personal Email"
              variant="outlined"
              value={formValues.personal_email}
              onChange={handleChange1}
            />
          </Grid>
        </Grid>



        <Grid container className={classes.root} spacing={5}>
          <Grid item xs={12}>
            <div className={styles.root}>
              <Accordion>
                <AccordionSummary
                  expandIcon={<ExpandMoreIcon />}
                  aria-controls="panel1a-content"
                  id="panel1a-header"
                  style={{ color: "#036dda" }}
                >
                  <Typography
                    className={`${styles.heading} common-form-page-title`}
                    style={{ color: "var(--hrms-primary-blue-end, #036dda)" }}
                  >
                    Other Settings
                  </Typography>
                </AccordionSummary>
                <AccordionDetails>
                  <Grid container className={classes.root} spacing={5}>
                    <Grid item xs={12} md={8}>
                      <Grid container spacing={5}>
                        <Grid item xs={12} sm={6}>
                          <TextField
                            fullWidth
                            id="outlined-basic"
                            name="location"
                            label="Location"
                            variant="outlined"
                            value={
                              formValues && formValues.location !== null
                                ? formValues.location
                                : null
                            }
                            onChange={handleChange1}
                            className={formErrors.location && "input-error"}
                            error={formErrors.location && true}
                          />
                          {formErrors.location && (
                            <span className="error">{formErrors.location}</span>
                          )}
                        </Grid>

                        <Grid item xs={12} sm={6}>
                          <TextField
                            fullWidth
                            id="outlined-basic"
                            name="mobileNo"
                            label="Contact Number"
                            variant="outlined"
                            value={
                              formValues && formValues.mobileNo !== null
                                ? formValues.mobileNo
                                : null
                            }
                            onChange={handleChange1}
                            className={formErrors.mobileNo && "input-error"}
                            error={formErrors.mobileNo && true}
                          />
                          {formErrors.mobileNo && (
                            <span className="error">{formErrors.mobileNo}</span>
                          )}
                        </Grid>

                        <Grid item xs={12} sm={6}>
                          <TextField
                            fullWidth
                            id="outlined-basic"
                            name="bankAccNo"
                            label="Bank Account Number"
                            variant="outlined"
                            value={
                              formValues && formValues.bankAccNo !== null
                                ? formValues.bankAccNo
                                : null
                            }
                            onChange={handleChange1}
                            className={formErrors.bankAccNo && "input-error"}
                            error={formErrors.bankAccNo && true}
                          />
                          {formErrors.bankAccNo && (
                            <span className="error">{formErrors.bankAccNo}</span>
                          )}
                        </Grid>

                        <Grid item xs={12} sm={6}>
                          <TextField
                            fullWidth
                            id="outlined-basic"
                            name="bankName"
                            label="Bank Name"
                            variant="outlined"
                            value={
                              formValues && formValues.bankName !== null
                                ? formValues.bankName
                                : null
                            }
                            onChange={handleChange1}
                            className={formErrors.bankName && "input-error"}
                            error={formErrors.bankName && true}
                          />
                          {formErrors.bankName && (
                            <span className="error">{formErrors.bankName}</span>
                          )}
                        </Grid>
                        <Grid item xs={12} sm={6}>
                          {renderSearchableSelect(
                            "designation",
                            "Designation",
                            getDropdownOptions("designation"),
                            "designation"
                          )}
                        </Grid>

                        <Grid item xs={12} sm={6}>
                          {renderSearchableSelect(
                            "reporting_person_id",
                            "Select User",
                            getDropdownOptions("reporting_person_id")
                          )}
                        </Grid>

                        <Grid item xs={12} sm={6}>
                          {renderSearchableSelect(
                            "department",
                            "Department",
                            getDropdownOptions("department")
                          )}
                        </Grid>

                        <Grid item xs={12} sm={6}>
                          <TextField
                            fullWidth
                            id="outlined-basic"
                            name="last_organization"
                            label="Last Organization"
                            variant="outlined"
                            error={formErrors.last_organization && true}
                            value={formValues.last_organization}
                            onChange={handleChange1}
                            className={formErrors.last_organization && "input-error"}
                          />
                          {formErrors.last_organization && (
                            <span className="error">{formErrors.last_organization}</span>
                          )}
                        </Grid>
                      </Grid>
                    </Grid>

                    <Grid item xs={12} md={4}>
                      <div
                        className={`${styles.uploadArea} ${dragActive ? styles.uploadAreaActive : ''}`}
                        onDragEnter={handleDrag}
                        onDragLeave={handleDrag}
                        onDragOver={handleDrag}
                        onDrop={handleDrop}
                        onClick={() => document.getElementById('raised-button-file').click()}
                      >
                        <input
                          accept="image/*"
                          className={styles.fileInput}
                          id="raised-button-file"
                          type="file"
                          ref={fileInputRef}
                          onChange={imgUpload}
                        />
                        <Avatar
                          src={resolveImageUrl(formValues.photo) || defaultAvatar}
                          alt="User profile image"
                          className="user-form-upload-avatar"
                        />
                        <Typography variant="subtitle2" style={{ color: 'var(--hrms-primary-blue-end, #036dda)', fontWeight: 'bold', marginBottom: '2px' }}>
                          Drag & Drop your file here
                        </Typography>
                        <Typography variant="caption" style={{ color: 'var(--hrms-primary-blue-end, #036dda)', marginBottom: '4px' }}>
                          or
                        </Typography>
                        <Button
                          variant="outlined"
                          color="primary"
                          component="span"
                          size="small"
                          startIcon={<CloudUploadIcon />}
                          style={{
                            textTransform: 'none',
                            fontWeight: 'bold',
                            padding: '2px 10px',
                            fontSize: '0.8rem',
                            color: 'var(--hrms-primary-blue-end, #036dda)',
                            borderColor: 'var(--hrms-primary-blue-border, #1864bc)'
                          }}
                        >
                          Upload a file
                        </Button>
                      </div>
                      {formValues.photo && (
                        <div style={{ textAlign: 'center', marginTop: '10px' }}>
                          <Button onClick={(e) => removeImg(e)} size="small" color="secondary">
                            Remove Image
                          </Button>
                        </div>
                      )}
                    </Grid>
                  </Grid>
                </AccordionDetails>
              </Accordion>
            </div>
          </Grid>
        </Grid>

        <Grid container className={classes.root} spacing={3}>
          <Grid item xs={12}>
            <div className="holiday-form-actions">
            {formErrors.submit && (
              <span className="error" style={{ width: "100%" }}>{formErrors.submit}</span>
            )}
            <Button
              type="submit"
              className="holiday-btn-submit"
              variant="contained"
              color="primary"
              style={{ textTransform: "none" }}
            >
              Save
            </Button>
            <Button
              type="button"
              className="holiday-btn-cancel"
              style={{ textTransform: "none" }}
              onClick={(e) => {
                e.preventDefault();
                props.history.push("/users");
              }}
            >
              Cancel
            </Button>
            </div>
          </Grid>
        </Grid>
      </form>
    </div>
  );
};

export default Addform;
